import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const ContentSearchPage = withSuspense(lazy(() => import('./company-media')));
export default ContentSearchPage;
